import React from "react";

import { sendGA4Tracking } from "~/components/tracking/google-analytics-4/apis";

import { useSitemap } from "./hooks";
import type { SitemapItemLink } from "./hooks";
import { Container, Item, List, ListContainer, SectionLabel, StyledBaseLink } from "./styles";

export type Props = {
  className?: string;
  onClick: (destination: string) => void;
};

export const HomeFooterSitemap: React.FunctionComponent<Props> = ({ className, onClick }) => {
  const { sitemap } = useSitemap();
  const renderAnchor = (link: SitemapItemLink) => (
    <StyledBaseLink
      pathname={link.url.alias}
      target={link.isExternal ?? link.isNewTag ? "_blank" : ""}
      onClick={() => {
        onClick(link.url.alias);
        sendGA4Tracking({
          action: "click",
          category: "footer",
          customized_parameters: {
            link_name: link.label,
          },
          subcategory: "",
        });
      }}
    >
      {link.label}
    </StyledBaseLink>
  );

  const renderSitemap = () =>
    sitemap.sections.map(section => (
      <ListContainer key={section.label}>
        <SectionLabel>{section.label}</SectionLabel>
        <List>
          {section.links.map((link, index) => (
            <Item key={index}>{renderAnchor(link)}</Item>
          ))}
        </List>
      </ListContainer>
    ));

  return <Container className={className}>{renderSitemap()}</Container>;
};

HomeFooterSitemap.displayName = "HomeFooterSitemap";
